import React from 'react';
import clsx from 'clsx';
import { useExpandableCard } from '../ExpandableCard';
import styles from './ExpandableCardContent.module.scss';

type ExpandableCardContentProps = React.ComponentProps<'div'>;

export const ExpandableCardContent: React.FC<ExpandableCardContentProps> = ({ children, className, ...props }) => {
    const { isExpanded } = useExpandableCard();

    if (!isExpanded) {
        return null;
    }

    return (
        <div
            className={clsx(styles.content, className)}
            {...props}
        >
            {children}
        </div>
    );
};
